<template>
  <img
    :src="icon"
    :alt="alt"
    :height="height"
    :class="iconClass"
    :style="iconStyle"
    @click="confirmAction"
  />
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "ConfirmAction",
  props: {
    icon: {
      type: String,
      default: require("@/assets/icons/trash-w.svg"),
    },
    alt: {
      type: String,
      default: "Confirm",
    },
    height: {
      type: [String, Number],
      default: 25,
    },
    iconClass: {
      type: String,
      default: "mr-2",
    },
    iconStyle: {
      type: String,
      default: "cursor: pointer;",
    },
    title: {
      type: String,
      default: "Êtes-vous sûr ?",
    },
    text: {
      type: String,
      default: "Cette action est irréversible.",
    },
    confirmText: {
      type: String,
      default: "Oui, supprimer",
    },
    cancelText: {
      type: String,
      default: "Annuler",
    },
    confirmColor: {
      type: String,
      default: "#dc3545", // Bootstrap danger red
    },
  },
  methods: {
    confirmAction() {
      Swal.fire({
        title: this.title,
        text: this.text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: this.confirmColor,
        cancelButtonColor: "#6c757d",
        confirmButtonText: this.confirmText,
        cancelButtonText: this.cancelText,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("confirm");
        }
      });
    },
  },
};
</script>
